import { BrowserAgent } from '@newrelic/browser-agent'

const enabled = process.env.VUE_APP_NEW_RELIC_ENABLED === 'true'

if (enabled) {
  const config = {
    licenseKey: process.env.VUE_APP_NEW_RELIC_LICENSE_KEY,
    applicationID: process.env.VUE_APP_NEW_RELIC_APPLICATION_ID,
    accountID: process.env.VUE_APP_NEW_RELIC_ACCOUNT_ID,
    trustKey: process.env.VUE_APP_NEW_RELIC_TRUST_KEY,
    agentID: process.env.VUE_APP_NEW_RELIC_AGENT_ID
  }

  const missing = Object.entries(config)
    .filter(([, value]) => !value)
    .map(([key]) => key)

  if (missing.length > 0) {
    throw new Error(`New Relic Browser configuration is incomplete: ${missing.join(', ')}`)
  }

  new BrowserAgent({
    init: {
      ajax: { deny_list: ['bam.nr-data.net'] },
      browser_consent_mode: { enabled: false },
      distributed_tracing: { enabled: true },
      performance: {
        capture_detail: false,
        capture_marks: false,
        capture_measures: true
      },
      privacy: { cookies_enabled: true }
    },
    info: {
      beacon: 'bam.nr-data.net',
      errorBeacon: 'bam.nr-data.net',
      licenseKey: config.licenseKey,
      applicationID: config.applicationID,
      sa: 1
    },
    loader_config: config
  })
}
